"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agreements = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var agreements = function (event) {
    var _a;
    var noOfAgreements = (_a = event.eventData.accountdetails) === null || _a === void 0 ? void 0 : _a.noOfAgreements;
    var resolvedNoOfAgreements = typeof noOfAgreements === 'string' ? noOfAgreements === null || noOfAgreements === void 0 ? void 0 : noOfAgreements.trim() : noOfAgreements;
    var eventData = {
        event: analytics_layer_1.AgreementsEventNames.Agreements,
        eventInfo: analytics_layer_1.AgreementsEventNames.Agreements,
        accountdetails: {
            accountid: event.eventData.accountdetails.accountid || consts_1.NOT_AVAILABLE,
            noOfAgreements: resolvedNoOfAgreements || consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.agreements = agreements;
